/**
 * Exhaustive guard for switch statements.
 * TypeScript narrows to `never` in default case if all enum cases are handled.
 * Throws at runtime if reached -- surfaces bugs immediately.
 */
export function assertNever(value: never): never {
  throw new Error(
    `Exhaustive guard failed: unexpected value ${JSON.stringify(value)}`
  );
}
